import { z } from 'zod';

// 新規登録フォームのバリデーションスキーマ
export const signUpSchema = z
  .object({
    name: z
      .string()
      .min(1, '名前は必須です')
      .min(2, '名前は2文字以上で入力してください'),
    phoneNumber: z
      .string()
      .min(1, '電話番号は必須です')
      .regex(/^[0-9]+$/, '有効な電話番号を入力してください')
      .regex(/^.{10,12}$/, '10~12文字で入力してください'),
    email: z
      .string()
      .min(1, 'メールアドレスは必須です')
      .email('有効なメールアドレスを入力してください'),
    password: z
      .string()
      .min(1, 'パスワードは必須です')
      .min(8, 'パスワードは8文字以上で入力してください'),
    passwordConfirmation: z.string().min(1, '確認用パスワードは必須です'),
    agree: z
      .boolean()
      .refine(
        (val) => val === true,
        'Stripeの利用規約とプライバシーポリシーに同意してください'
      ),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'パスワードと確認用パスワードが一致しません',
    path: ['passwordConfirmation'],
  });
